import crypto from 'crypto';
import { promisify } from 'util';
export async function createRSAKeyPair(keyLength) {
    const generateKeyPair = promisify(crypto.generateKeyPair);
    const { publicKey, privateKey } = await generateKeyPair('rsa', {
        modulusLength: keyLength,
        publicKeyEncoding: {
            type: 'spki',
            format: 'pem',
        },
        privateKeyEncoding: {
            type: 'pkcs8',
            format: 'pem',
        },
    });
    return { privateKey, publicKey };
}
//# sourceMappingURL=createRSAKeyPair.js.map